import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="components--forms--array-field"
export default class extends Controller {
  static targets = [
    "template",
    "target"
  ]

  add() {
    let template = this.templateTarget.cloneNode(true).content.firstElementChild

    this.targetTarget.parentNode.insertBefore(template, this.targetTarget);
  }

  remove(event) {
    event.target.closest("[data-array-element]").remove()
  }
}
